import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';
import { changeSeconds } from '../../app/utils';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 16,
    },
    line: {
      flexGrow: 1,
      borderBottom: `1px solid ${color.$9}`,
    },
    text: {
      margin: '0 16px',
      maxWidth: '80%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      color: color.$11,
    },
    order: { display: 'flex', alignItems: 'center', marginBottom: 24 },
    value: {
      width: '100%',
      textAlign: 'center',
      color: color.$13,
      fontSize: '15px',
      lineHeight: '21px',
    },
  },
  {
    name: 'PreviewWaitNode',
  },
);

const PreviewWaitNode = ({ node }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data } = node || {};
  const { waitTime } = data || {};

  const waitText = useMemo(() => {
    const year = changeSeconds(waitTime, 'year');
    const month = changeSeconds(waitTime, 'month');
    const day = changeSeconds(waitTime, 'day');
    const hour = changeSeconds(waitTime, 'hour');
    const minute = changeSeconds(waitTime, 'minute');
    const second = changeSeconds(waitTime, 'second');

    if (waitTime === 0) {
      return t('message-node.not-wait');
    }

    return `${year ? `${t('message-node.year', { year })}` : ''}${
      month ? `${t('message-node.month', { month })}` : ''
    }${day ? `${t('message-node.day', { day })}` : ''}${
      hour ? `${t('message-node.hour', { hour })}` : ''
    }${minute ? `${t('message-node.minute', { minute })}` : ''}${
      second ? `${t('message-node.second', { second })}` : ''
    }`;
  }, [waitTime]);

  return (
    <div className={classes.root}>
      <div className={classes.order}>
        <span className={classes.line} />
        <span className={classes.text}>{t('wait')}</span>
        <span className={classes.line} />
      </div>
      <div className={classes.value}>{waitText}</div>
    </div>
  );
};

export default PreviewWaitNode;
